module.exports = __webpack_public_path__ + "img/img_industries3.44cbd76b.jpg";